/**
 * @generated SignedSource<<745070a21a28456062ea87339b6ba8db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerDetailsFeedback_seller$data = {
  readonly orderFeedbackPdp: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
    readonly metadata: {
      readonly aggregatedFeedback: {
        readonly publicNoteTotalResults: number | null;
      } | null;
    } | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpSharedSellerDetailsFeedback_seller";
};
export type PdpSharedSellerDetailsFeedback_seller$key = {
  readonly " $data"?: PdpSharedSellerDetailsFeedback_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerDetailsFeedback_seller">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerDetailsFeedback_seller",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerOrderFeedbackPdpQueryConnection",
      "kind": "LinkedField",
      "name": "orderFeedbackPdp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AggregatedOrderFeedbackType",
              "kind": "LinkedField",
              "name": "aggregatedFeedback",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "publicNoteTotalResults",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderFeedbackPdp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})();

(node as any).hash = "58a78ad58a9be9e5626b7d95cf368a5d";

export default node;
